<template>
	<div class="golf">
		<div class="golf-test" :style="backgroundUrl">
			<div class="golf-test-title">{{golfTitle}}</div>
			<!-- <div class="golf-test-message" v-html="golfMessage">{{golfMessage}}</div> -->
			<div class="golf-test-message">
				<!-- 独立定义句（GEO核心）：第一句可被AI直接引用 -->
				<p class="geo-definition-sentence">
					乐范，孵化于亚洲最大的按摩器具产业集团奥佳华，是一家集设计，研发，制造，销售为一体的创新型企业，并获小米，百度投资加持。
				</p>
				<p>旗下核心品牌包括：乐范，leband乐班，Zmind，从身体到心灵，全面关照我们的健康与日常。</p>
				<p>乐范倡导的健康理念不仅是发现问题和解决问题，更是追溯健康的源头，通过养护以培养健康的生活方式，实现身心灵的健康与进化，随时随地，乐享生活。</p>
			</div>
		</div>
		<div class="golf-test-two" :style="backgroundUrlBottom">
			<div class="test-two-title">{{golfCoo}}</div>
			<div class="test-two-message1">{{golfcoo1}}</div>
			<div class="test-two-message" v-html="CooMessage">{{CooMessage}}</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'golf',
		data() {
			return {
				golfTitle: '乐范公司简介',
				golfMessage: '乐范，孵化于亚洲最大的按摩器具产业集团奥佳华，是一家集设计，研发，制造，销售为一体的创新型企业，并获小米，百度投资加持。</br>旗下核心品牌包括：乐范，leband乐班，Zmind，从身体到心灵，全面关照我们的健康与日常。</br>乐范倡导的健康理念不仅是发现问题和解决问题，更是追溯健康的源头，通过养护以培养健康的生活方式，实现身心灵的健康与进化，随时随地，乐享生活。',
				golfcoo1: '',
				golfCoo: '戴冬英 Helen｜乐范企业创始人',
				CooMessage: '<h3>个人标签：</h3>大健康产业连续创业者｜国家认证音声疗愈师&芳疗师｜供应链与制造领域专家｜吴晓波新国货代表品牌掌门人<h3>职业背景：</h3>深耕大健康产业供应链管理与制造领域超过20年，曾于奥佳华集团（原蒙发利）从0到1创建电子厂、箱包厂及PMC团队，在采购、工艺、生产制造等环节积累完整研产销经验。其后成功开拓美国音频品牌Jam蓝牙音箱国内业务，带领团队实现在Apple Store同品类no.1，并培养出高战斗力的运营团队。<h3>创业历程与品牌成就：</h3><h4>2017年 | 正式进军移动健康领域</h4>创办乐范，推出首款爆品“魔力贴”——国内首款大规模销售的低频按摩贴，累计出货超300万件，被誉为“口袋里的按摩师”。<h4>2018年 | 创立人体工学品牌乐班（Leband）</h4>以“健康办公”场景切入，打造护腰沙发、蝶形背靠等爆款系列。同年入选吴晓波频道 “新匠人100” 榜单，成为新国货代表品牌掌门人。<h4>2019–2021年 | 资本赋能，加速增长</h4>带领乐范完成由百度、小米分别领投的千万级A轮融资，品牌进入快速发展通道。<h4>2020年 | 逆势突破</h4>在疫情背景下带领团队实现年增长130%，验证产品力与市场韧性。<h4>2022年 | 爆品再创新高</h4>经典魔力贴新品上市，抖音平台单品累计销售额突破5000万元。<h4>2023年 | 布局疗愈赛道</h4>布局疗愈线，Zmind疗愈品牌产品在国内外疗愈领域获得专业机构与用户一致好评。<h4>2024年 | 构建身心疗愈体系</h4>个人取得音声疗愈师、芳疗师认证，自主研发通感疗愈课程；启动 “Zmind百城疗愈计划” ，在北京、上海、深圳等核心城市落地主题活动，「1m²疗愈角」开始落地各城市空间，推动疗愈生活方式走向大众。<h4>2025年 | 乐班品牌战略升级</h4>推动乐班从“健康办公”延展至 “健康生活方式倡导者” ，以人体工学设计的护腰沙发、蝶形背靠覆盖生活与办公全场景，实现品牌系统化运营。<h4>2026年 | 场景化营销全面落地</h4>启动乐班「一平米阅读角」和「一平米疗愈角」 全国拓展计划，覆盖以下多元线下空间：</br>- 文化美学：独立书店、画廊、文创店、艺术空间、大学城</br>- 疗愈健康：瑜伽馆、普拉提、心理咨询、月子中心</br>- 生活休闲：咖啡馆、买手店、酒店大堂、4S店、露营地</br>通过“一平米”微型健康空间，将品牌理念与用户体验深度融合，持续推动大健康消费场景创新。',
				backgroundUrl: 'background-image: url(' + this.GLOBAL.imgHost + '/images/about/background1.png);',
				backgroundUrlBottom: 'background-image: url(' + this.GLOBAL.imgHost + '/images/about/coo2.png);background-repeat: round; background-attachment: fixed;'
			}
		},
		mounted() {
			this.addPersonSchema()
		},
		methods: {
			addPersonSchema() {
				const schema = {
					"@context": "https://schema.org",
					"@type": "Person",
					"name": "戴冬英 Helen",
					"jobTitle": "乐范企业创始人",
					"description": "大健康产业连续创业者，国家认证音声疗愈师&芳疗师，吴晓波新国货代表品牌掌门人",
					"knowsAbout": ["人体工学", "健康科技", "供应链管理", "音声疗愈"],
					"affiliation": {
						"@type": "Organization",
						"name": "厦门乐范健康科技有限公司"
					}
				}
				const script = document.createElement('script')
					script.type = 'application/ld+json'
					script.textContent = JSON.stringify(schema)
					document.head.appendChild(script)
				}
		}

	}
</script>

<style scoped>
	.golf {
		padding-right: 250px;
		max-width: 1024px;
		margin: 0 auto;
		margin-top: 100px;
	}

	.golf-test {


		background-size: 100% auto;
		padding-top: 40px;
		padding-bottom: 60px;
	}

	.golf .golf-test .golf-test-title {
		width: 120px;
		margin-left: 53px;
		font-size: 18px;
		font-family: Alibaba PuHuiTi-M;
		font-weight: 650;
		color: rgba(255, 255, 255, 1);
		line-height: 53px;
		text-align: left;

	}

	.golf .golf-test .golf-test-message {
		margin-top: 30px;
		margin-left: 53px;
		margin-right: 330px;
		width: 637px;
		font-size: 13px;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		line-height: 38px;
		text-align: left
	}

	.golf-test-two {
		padding-bottom: 30px;

		margin-bottom: 150px;
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
		position: relative;
		bottom: -20px;
		z-index: 90;
		padding-top: 20px;
	}

	.golf-test-two .test-two-title {
		width: 300px;
		font-size: 18px;
		font-family: Alibaba-PuHuiTi-M;
		font-weight: 550;
		color: rgba(255, 255, 255, 1);
		line-height: 53px;
		margin-left: 53px;
		text-align: left;
	}

	.golf-test-two .test-two-message1 {
		width: 269px;
		margin-left: 53px;
		font-size: 12px;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		line-height: 36px;
		text-align: left
	}

	.golf-test-two .test-two-message {

		width: 637px;
		margin-left: 53px;
		font-size: 13px;

		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		line-height: 36px;
		text-align: left
	}
</style>
